import { forwardRef, type HTMLAttributes } from 'react';
import styled from 'styled-components';

import {
  FlexProps,
  OverflowProps,
  SizeProps,
  SpacingProps,
  StyledFlexProps,
  StyledOverflowProps,
  StyledSizeProps,
  StyledSpacingProps,
  flexStyles,
  mapStyledProps,
  overflowStyles,
  sizeStyles,
  spacingStyles,
} from '../../styles';

const Container = styled.div<
  StyledFlexProps & StyledSpacingProps & StyledSizeProps & StyledOverflowProps
>`
  display: flex;
  box-sizing: border-box;
  ${flexStyles}
  ${spacingStyles}
  ${sizeStyles}
  ${overflowStyles}
`;

type Props = HTMLAttributes<HTMLDivElement> &
  FlexProps &
  SpacingProps &
  SizeProps &
  OverflowProps;

const Flex = forwardRef<HTMLDivElement, Props>((props, forwardedRef) => {
  const mappedProps = mapStyledProps(props);

  return <Container ref={forwardedRef} {...mappedProps} />;
});

Flex.displayName = 'Flex';

export default Flex;
